
import { BlackMostros } from './blackmostros.js';
import {
  when_available,
  when_document_ready,
  } from './blackmostros.method.js';
// leads module
import { start_leads } from './blackmostros.leads.js';
// ~ import { start_subscriptions } from './blackmostros.subscription.js';


/*
BlackMostros({})
.then((data) => {
    // ~ console.log(data);
    console.log('Running...')
    })
.catch((data) => {
    console.log('error:', data);
    });
*/

// ~ async function main () {
function main ($) {
    var _bms = BlackMostros($);

    // init when document is ready
    // with this menu dont show fast
    when_document_ready(function () {
        _bms.init();

        // ~ var _bms = await BlackMostros(document);
        // ~ var _wa = await when_available();
        window._bms = _bms;
        // ~ console.log(_wa);
        // ~ when_available('_bms.minner', function(){
        if (_bms.props._enable.miner) {
            window.accept_minner = _bms.minner.accept_minner;
        };
        // ~ });

        // dont work
        // ~ when_available('angular', start_leads);


    });

    // ~ when_available('angular', start_leads);

    //
    // .then({
    //     name: '_bms.minner',
    //     method: function(){
    //
    //         window.accept_minner = _bms.minner.accept_minner;
    //         // ~ window.accept_minner = _bms.minner.accept_minner
    //         console.log(
    //             _bms,
    //             window._bms,
    //             window.accept_minner,
    //         );
    //
    //     },
    // });
}
main(document);

function _load_angular_modules(){
    let _ele = document.querySelector('section.blog-featured');
    if (_ele) {
        start_leads();
    }
    /*
    _ele = document.querySelector('section.subscription');
    if (_ele) {
        start_subscriptions();
    }
    */
}
when_available('angular', _load_angular_modules);
